import moment from 'moment-timezone'

import api from 'common/api'

import types from './types'

const dispatchedFetchBlackoutDates = (dispatch, highSchoolId) => {
  const thisYear = moment().year()
  dispatch({
    type: types.FETCH_BLACKOUT_DATES_START,
  })
  api
    .get(`/api/highschools/${highSchoolId}/blackoutdays?year=${thisYear}&year=${thisYear + 1}`)
    .then((result) => {
      dispatch({
        type: types.UPDATE_BLACKOUT_DATES,
        payload: result,
      })
    })
    .catch(() => {
      dispatch({
        type: types.UPDATE_BLACKOUT_DATES_FAILURE,
      })
    })
}

const fetchBlackoutDates = (highSchoolId) => {
  return (dispatch) => dispatchedFetchBlackoutDates(dispatch, highSchoolId)
}

const updateBlackoutDates = (highSchoolId, dates) => {
  return (dispatch) => {
    dispatch({
      type: types.UPDATE_BLACKOUT_DATES_START,
    })
    return api
      .put(`/api/highschools/${highSchoolId}/blackoutdays`, dates)
      .then(() => {
        return dispatchedFetchBlackoutDates(dispatch, highSchoolId)
      })
      .catch(() => {
        dispatch({
          type: types.UPDATE_BLACKOUT_DATES_FAILURE,
        })
        return Promise.reject()
      })
  }
}

export default {
  fetchBlackoutDates,
  updateBlackoutDates,
}
